import axios, { type AxiosInstance, type CreateAxiosDefaults } from 'axios'
import { apiPrefix } from './runtimeConfig'

/**
 * axios-Client fuer die Platform-/Cockpit-API (TQ #409): die Basis-URL kommt aus
 * der Laufzeit-Config und wird je Request gelesen (Clients werden beim
 * Modul-Import erzeugt, die Config erst danach geladen).
 */
export function createApiClient(defaults: CreateAxiosDefaults = {}): AxiosInstance {
  const client = axios.create(defaults)
  client.interceptors.request.use((req) => {
    req.baseURL = apiPrefix()
    return req
  })
  return client
}
